import { render } from "./sizing_tables.vue?vue&type=template&id=34aa8796"
import script from "./sizing_tables.vue?vue&type=script&lang=js"
export * from "./sizing_tables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__